import type {State} from '../../../../../reducers/types'
import {getBuild, getBuildsData, makeGetBuilds} from '../../../../../selectors'
import type {BuildId, BuildTypeId, NormalizedBuild} from '../../../../../types'
import startedBefore from '../../../../../utils/startedBefore'

import {getDeploymentsLocator, getLastDeployedBuildLocator} from './Deployments.rest'
import type {LastDeployedBuildConfig} from './Deployments.types'

export const getLastDeployedBuildId = (
  state: State,
  config: LastDeployedBuildConfig,
): BuildId | null | undefined => getBuildsData(state, getLastDeployedBuildLocator(config)).data[0]
export const getIsObsolete = (
  state: State,
  buildId: BuildId,
  config: LastDeployedBuildConfig,
): boolean => {
  const lastDeployedBuild = getBuild(state, getLastDeployedBuildId(state, config))
  const build = getBuild(state, buildId)
  return build == null || (lastDeployedBuild != null && startedBefore(build, lastDeployedBuild))
}
export const getDeploymentId = (
  state: State,
  buildId: BuildId,
  deployTypeId: BuildTypeId,
): BuildId | null | undefined =>
  makeGetBuilds()(state, getDeploymentsLocator(buildId))
    .filter(build => build.buildType === deployTypeId)
    .reduce<NormalizedBuild | null>(
      (acc, build) => (acc != null && startedBefore(build, acc) ? acc : build),
      null,
    )?.id
